import { render, staticRenderFns } from "./vCard.vue?vue&type=template&id=27bdbdc0&scoped=true"
import script from "./vCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./vCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdbdc0",
  null
  
)

export default component.exports